import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({content=''}) => {
  return (
    <div className="loading-container">
      <div className="spinner-box">
        <div className="pulse-ring"></div>
        <div className="spinner"></div>
      </div>
      <p className="loading-text">{content}</p>
    </div>
  );
};

export default LoadingSpinner;